import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <p>
        &copy; {new Date().getFullYear()} Bungalow64 Technologies Ltd. All
        rights reserved.
      </p>
      <nav className="footer-links">
        <Link to="/contact">Contact</Link>
        <Link to="/Policies/terms-of-use">Terms & Conditions</Link>
        <Link to="/Policies/privacy-policy">Privacy Policy</Link>
        <Link to="/Policies/refund-and-cancellation">
          Refund & Cancellation Policy
        </Link>
      </nav>
    </footer>
  );
};

export default Footer;
